import { HOVER_HINT_PANEL_SELECTOR } from "./viewportAnchoredPopover";

export { HOVER_HINT_PANEL_SELECTOR };

/** Hover/focus wrap around the hint trigger. */
export const HOVER_HINT_ANCHOR_SELECTOR = "[data-hub-hover-hint-anchor]";

/** Shared by a parent hint and nested hints portaled from inside it. */
export const HOVER_HINT_ROOT_ATTR = "data-hub-hover-hint-root";

/** Time to travel from the trigger onto this hint's panel (or a nested hint in the same tree). */
export const HOVER_HINT_CLOSE_DELAY_MS = 180;

function eventElement(node: EventTarget | null): Element | null {
  if (node instanceof Element) return node;
  if (node instanceof Node) return node.parentElement;
  return null;
}

export function hoverHintRootIdFromNode(node: EventTarget | null): string | null {
  const element = eventElement(node);
  if (element == null) return null;
  const panel = element.closest(HOVER_HINT_PANEL_SELECTOR);
  if (panel == null) return null;
  const root = panel.getAttribute(HOVER_HINT_ROOT_ATTR);
  return root != null && root !== "" ? root : null;
}

export function shouldKeepHoverHintOpen(args: {
  isInsideAnchor: boolean;
  isInsideThisHintTree: boolean;
}): boolean {
  return args.isInsideAnchor || args.isInsideThisHintTree;
}

export function isNodeInsideHoverHintAnchor(
  node: EventTarget | null,
  anchor: { contains: (other: Node) => boolean } | null,
): boolean {
  if (anchor == null || !(node instanceof Node)) {
    return false;
  }
  return anchor.contains(node);
}

export function isNodeInsideThisHintTree(node: EventTarget | null, rootId: string): boolean {
  if (rootId === "") return false;
  return hoverHintRootIdFromNode(node) === rootId;
}

/** Pointer is over a different hover hint (another nav row, another ? glyph, etc.). */
export function isNodeInsideForeignHoverHint(
  node: EventTarget | null,
  anchor: { contains: (other: Node) => boolean } | null,
  rootId: string,
): boolean {
  if (isNodeInsideHoverHintAnchor(node, anchor)) return false;
  if (isNodeInsideThisHintTree(node, rootId)) return false;
  const element = eventElement(node);
  if (element == null) return false;
  if (element.closest(HOVER_HINT_ANCHOR_SELECTOR) != null) return true;
  return hoverHintRootIdFromNode(node) != null;
}

export function isNodeInsideHoverHintSurface(
  node: EventTarget | null,
  anchor: { contains: (other: Node) => boolean } | null,
  rootId: string,
): boolean {
  return shouldKeepHoverHintOpen({
    isInsideAnchor: isNodeInsideHoverHintAnchor(node, anchor),
    isInsideThisHintTree: isNodeInsideThisHintTree(node, rootId),
  });
}
